import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { Activity, Send, AlertTriangle, BarChart3 } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-white/[0.06] bg-[#05050A] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-cyan-400 to-cyan-600 grid place-items-center">
              <Activity className="h-5 w-5 text-[#05050A]" />
            </div>
            <div>
              <div className="text-base font-bold">Dr Trade Scalper Pro</div>
              <div className="text-[10px] text-cyan tracking-[0.2em] uppercase font-mono">MT5 Expert Advisor</div>
            </div>
          </div>
          <p className="text-sm text-zinc-400 max-w-md whitespace-pre-line">{t("footer.tagline")}</p>
          <div className="mt-5 inline-flex items-start gap-2 text-xs text-amber-400/90 bg-amber-400/5 border border-amber-400/20 rounded-md px-3 py-2 max-w-md">
            <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
            <span>{t("footer.legal")}</span>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3">Navigation</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/features" className="hover:text-white">{t("nav.features")}</Link></li>
            <li><Link to="/pricing" className="hover:text-white">{t("nav.pricing")}</Link></li>
            <li><Link to="/affiliates" className="hover:text-white">{t("nav.affiliates")}</Link></li>
            <li><Link to="/copytrading" className="hover:text-white" data-testid="footer-link-copytrading">Copytrading</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3">Support</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/tutorials" className="hover:text-white">{t("nav.tutorials")}</Link></li>
            <li><Link to="/analytics" className="hover:text-white inline-flex items-center gap-1.5" data-testid="footer-link-analytics"><BarChart3 className="h-3 w-3" /> Analytics</Link></li>
            <li><Link to="/faq" className="hover:text-white">{t("nav.faq")}</Link></li>
            <li><Link to="/contact" className="hover:text-white">{t("nav.contact")}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center">
          <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-3">{t("footer.payments_accepted")}</div>
          <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap" aria-label="Moyens de paiement acceptés">
            <img src="/assets/payment/usdt-trc20.png" alt="USDT TRC20" className="h-7 sm:h-8 w-auto opacity-90" loading="lazy" draggable="false" />
            <img src="/assets/payment/mobile-money.png" alt="Orange Money · Moov · MTN · Wave" className="h-7 sm:h-8 w-auto opacity-90" loading="lazy" draggable="false" />
            <img src="/assets/payment/cards.png" alt="Visa · Mastercard" className="h-7 sm:h-8 w-auto opacity-90" loading="lazy" draggable="false" />
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-500">
          <div>{t("footer.copy")}</div>
          <div className="font-mono text-zinc-600">v1.03 · MQL5 Build · 2026</div>
        </div>
      </div>
    </footer>
  );
}
